var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{class:`image-list ${_vm.classes}`},_vm._l((_vm.items),function(item,index){return _c('li',{key:index},[(item.heading)?_c('h2',{domProps:{"innerHTML":_vm._s(item.heading)}}):_vm._e(),_c('img',{class:item.class || '',style:(`height:${item.height || '100%'}`),attrs:{"src":item.src,"alt":item.alt || '...'}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }